import { createContext } from 'react';

// Types
import { MerchantDoc, RegDetail } from 'services/types';
import {
  FetchActiveGstsPayload,
  FetchMerchantDocsPayload,
  FetchRegDetailsPayload,
  UpdateAddressPayload,
  UpdateDocDetailsPayload,
  UpdateRegDetailsPayload,
  VerifyGstinPayload,
} from './types';

export const OnboardingContext = createContext<{
  fetchRegDetails: (data: FetchRegDetailsPayload) => Promise<void>;
  fetchMerchantDocs: (data: FetchMerchantDocsPayload) => Promise<void>;
  fetchActiveGsts: (data: FetchActiveGstsPayload) => Promise<void>;
  updateRegDetails: (data: UpdateRegDetailsPayload) => Promise<void>;
  updateDocDetails: (data: UpdateDocDetailsPayload) => Promise<void>;
  updateAddressField: (data: UpdateAddressPayload) => Promise<void>;
  verifyGstinDetails: (data: VerifyGstinPayload) => Promise<void>;
  data: {
    regDetails: {
      [key: string]: RegDetail;
    };
    merchantDocs: {
      [key: string]: MerchantDoc;
    };
    activeGsts: string[];
  };
}>(null);
